export const TemplatesHeader = [
  { name: 'createdAt', label: 'ردیف', isSortable: false, align: 'left' },
  { name: 'title', label: 'عنوان', isSortable: false, align: 'left' },
  { name: 'createdAt', label: 'تاریخ درخواست', isSortable: true, align: 'left' },
  { name: 'category', label: 'کد بازاریابی', isSortable: false, align: 'left' },
  { name: 'category', label: 'وضعیت اکانت', isSortable: false, align: 'left' },
  { name: 'category', label: 'وضعیت جایگاه', isSortable: false, align: 'left' },
  { name: 'category', label: 'شماره پشتیبانی', isSortable: false, align: 'left' },
  { name: 'category', label: 'آدرس', isSortable: false, align: 'center' },
  { name: 'category', label: 'نوع سایت', isSortable: false, align: 'left' },
  { name: 'category', label: 'زیر دامنه انتخابی', isSortable: false, align: 'left' },
  { name: 'status', label: 'وضعیت', isSortable: false, align: 'left' },
  { name: 'status', label: 'نتیجه بررسی', isSortable: false, align: 'left' },
  { name: 'category', label: 'عملیات', isSortable: false, align: 'left' },
];
export const RecommendationTagHeader = [
  { name: 'index', label: 'ردیف', isSortable: false, align: 'left', width: 60 },
  { name: 'createdAt', label: 'تاریخ ایجاد', isSortable: false, align: 'left' },
  { name: 'title', label: 'عنوان برچسب', isSortable: false, align: 'left', width: 'auto' },
  { name: 'category', label: 'دسته بندی', isSortable: false, align: 'left' },
  { name: 'level', label: 'سطح برچسب', isSortable: false, align: 'left', width: 60 },
  { name: 'relatedQuestion', label: 'تعداد سوال مرتبط', isSortable: false, align: 'left', width: 120 },
  { name: 'relatedProduct', label: 'تعداد محصول مرتبط', isSortable: false, align: 'left', width: 120 },
  { name: 'status', label: 'وضعیت', isSortable: false, align: 'left', width: 120 },
  { name: 'operator', label: 'عملیات', isSortable: false, align: 'right' },
];
export const RecommendationRelationHeader = [
  { name: 'index', label: 'ردیف', isSortable: false, align: 'left', width: 50 },
  { name: 'name', label: 'محصول', isSortable: false, align: 'left', width: 300 },
  { name: 'tags', label: 'برچسب ها', isSortable: false, align: 'left', width: 'auto' },
  { name: 'operator', label: 'عملیات', isSortable: false, align: 'right' },
];
export const RecommendationConflictHeader = [
  { name: 'index', label: 'ردیف', isSortable: false, align: 'left', width: 80 },
  { name: 'createdAt', label: 'تاریخ ایجاد', isSortable: false, align: 'left', width: 80 },
  { name: 'title', label: 'محصول اصلی', isSortable: false, align: 'left' },
  { name: 'category', label: 'محصول متضاد', isSortable: false, align: 'left' },
  { name: 'level', label: 'نوع تضاد', isSortable: false, align: 'left', width: 80 },
  { name: 'relatedQuestion', label: 'نمایش پیام به مشتری', isSortable: false, align: 'left', width: 140 },
  { name: 'relatedProduct', label: 'علت تضاد و دستورالعمل', isSortable: false, align: 'left' },
  { name: 'operator', label: 'عملیات', isSortable: false, align: 'left' },
];
export const RecommendationQuestionHeader = [
  { name: 'index', label: 'ردیف', isSortable: false, align: 'left', width: 60 },
  { name: 'createdAt', label: 'تاریخ ایجاد', isSortable: false, align: 'left', width: 80 },
  { name: 'title', label: 'عنوان سوال', isSortable: false, align: 'left', width: 'auto' },
  { name: 'category', label: 'دسته بندی', isSortable: false, align: 'left', width: 120 },
  { name: 'level', label: 'نوع سوال', isSortable: false, align: 'left', width: 120 },
  { name: 'relatedTag', label: 'تعداد برچسب مرتبط', isSortable: false, align: 'left', width: 80 },
  { name: 'relatedProduct', label: 'تعداد محصول مرتبط', isSortable: false, align: 'left', width: 80 },
  { name: 'status', label: 'وضعیت', isSortable: false, align: 'left', width: 80 },
  { name: 'operator', label: 'عملیات', isSortable: false, align: 'left', width: 80 },
];

export const UpdateRequestHeaders = [
  { name: 'createdAt', label: 'ردیف', isSortable: false, align: 'left' },
  { name: 'title', label: 'عنوان', isSortable: false, align: 'left' },
  { name: 'createdAt', label: 'تاریخ درخواست', isSortable: true, align: 'left' },
  { name: 'category', label: 'کد بازاریابی', isSortable: false, align: 'left' },
  { name: 'category', label: 'شماره پشتیبانی', isSortable: false, align: 'left' },
  { name: 'category', label: 'تم انتخابی', isSortable: false, align: 'left' },
  { name: 'category', label: 'نوع سایت', isSortable: false, align: 'left' },
  { name: 'category', label: 'زیر دامنه انتخابی', isSortable: false, align: 'left' },
  { name: 'category', label: 'عملیات', isSortable: false, align: 'left' },
];
